const Layout = () => import(/* webpackChunkName: "base" */'@/components/common/Layout');
const ProjectWorkbench = () => import(/* webpackChunkName: "projectManage" */'@/components/pages/projectManage/Workbench');
const ProjectWorkflowDetail = () => import(/* webpackChunkName: "projectManage" */'@/components/pages/projectManage/ProjectWorkflowDetail');
const ProjectCreatePage = () => import(/* webpackChunkName: "projectManage" */'@/components/pages/projectManage/ProjectCreatePage');
const LandmarkOperate = () => import(/* webpackChunkName: "projectManage" */'@/components/pages/projectManage/LandmarkOperate');
const MemberOperate = () => import(/* webpackChunkName: "projectManage" */'@/components/pages/projectManage/MemberOperate');
const MeetingOperate = () => import(/* webpackChunkName: "projectManage" */'@/components/pages/projectManage/MeetingOperate');

export default [
  {
    path: '/project-manage',
    name: 'projectManage',
    meta: {
      roles: ['WF_PM_QUERY']
    },
    component: Layout,
    children: [
      {
        path: 'project-bench',
        name: 'projectBench',
        meta: {
          roles: ['WF_PM_QUERY'],
          title: '项目管理',
          icon: 'project-manage',
          activeMenu: '/project-manage/project-bench',
          componentName: 'ProjectWorkbench',
          breadcrumb: [
            {
              name: '项目管理',
              path: '/project-manage/project-bench'
            }
          ]
        },
        component: ProjectWorkbench
      },
      {
        path: 'edit-project-workflow/:id',
        props: true,
        name: 'editProjectWorkflow',
        meta: {
          roles: ['WF_PM_DETAIL_QUERY'],
          title: '项目详情',
          hidden: true,
          activeMenu: '/project-manage/project-bench',
          componentName: 'ProjectWorkflowDetail',
          breadcrumb: [
            {
              name: '项目管理',
              path: '/project-manage/project-bench'
            },
            {
              name: '项目详情',
              path: '/project-manage/edit-project-workflow/:id'
            }
          ]
        },
        component: ProjectWorkflowDetail
      },
      {
        path: 'create-project-workflow',
        name: 'createProjectWorkflow',
        meta: {
          roles: ['WF_PM_ADD'],
          title: '新建项目',
          hidden: true,
          activeMenu: '/project-manage/project-bench',
          componentName: 'ProjectCreatePage',
          breadcrumb: [
            {
              name: '项目管理',
              path: '/project-manage/project-bench'
            },
            {
              name: '新建项目',
              path: '/project-manage/create-project-workflow'
            }
          ]
        },
        component: ProjectCreatePage
      },
      {
        path: ':projectId/create-landmark',
        name: 'createLandmark',
        props: true,
        meta: {
          roles: ['WF_PM_LANDMARKS_ADD'],
          title: '新建里程碑',
          hidden: true,
          activeMenu: '/project-manage/project-bench',
          componentName: 'LandmarkOperate',
          breadcrumb: [
            {
              name: '项目管理',
              path: '/project-manage/project-bench'
            },
            {
              name: '新建里程碑',
              path: '/project-manage/:projectId/create-landmark'
            }
          ]
        },
        component: LandmarkOperate
      },
      {
        path: ':projectId/edit-landmark/:landmarkId',
        name: 'editLandmark',
        props: true,
        meta: {
          roles: ['WF_PM_LANDMARKS_QUERY'],
          title: '编辑里程碑',
          hidden: true,
          activeMenu: '/project-manage/project-bench',
          componentName: 'LandmarkOperate',
          breadcrumb: [
            {
              name: '项目管理',
              path: '/project-manage/project-bench'
            },
            {
              name: '编辑里程碑',
              path: '/project-manage/:projectId/edit-landmark/:landmarkId'
            }
          ]
        },
        component: LandmarkOperate
      },
      {
        path: ':projectId/create-member',
        name: 'createProjectMember',
        props: true,
        meta: {
          roles: ['WF_PM_MEMBERS_ADD'],
          title: '新建项目成员',
          hidden: true,
          activeMenu: '/project-manage/project-bench',
          componentName: 'MemberOperate',
          breadcrumb: [
            {
              name: '项目管理',
              path: '/project-manage/project-bench'
            },
            {
              name: '新建项目成员',
              path: '/project-manage/:projectId/create-member'
            }
          ]
        },
        
        component: MemberOperate
      },
      {
        path: ':projectId/create-meeting',
        name: 'createProjectMeeting',
        props: true,
        meta: {
          roles: ['WF_PM_METTINGS_ADD'],
          title: '新建会议',
          hidden: true,
          activeMenu: '/project-manage/project-bench',
          componentName: 'MeetingOperate',
          breadcrumb: [
            {
              name: '项目管理',
              path: '/project-manage/project-bench'
            },
            {
              name: '新建会议',
              path: '/project-manage/:projectId/create-meeting'
            }
          ]
        },
        component: MeetingOperate
      },
      {
        path: ':projectId/edit-meeting/:meetingId',
        name: 'editProjectMeeting',
        props: true,
        meta: {
          roles: ['WF_PM_METTINGS_QUERY'],
          title: '编辑会议',
          hidden: true,
          activeMenu: '/project-manage/project-bench',
          componentName: 'MeetingOperate',
          breadcrumb: [
            {
              name: '项目管理',
              path: '/project-manage/project-bench'
            },
            {
              name: '编辑会议',
              path: '/project-manage/:projectId/edit-meeting/:meetingId'
            }
          ]
        },
        component: MeetingOperate
      },
    ]
  },
];



// WEBPACK FOOTER //
// ./src/router/projectManage.js